import q from 'q';
import {MessengerBuilder} from "./messenger";

export default class DesktopDataProvider {
	constructor() {
		this.q = q;
		const Messenger = new MessengerBuilder(this.q);
		this.messenger = new Messenger(this.q);
		this.defaultTimeout = 100;
	}
	
	getTimeoutPromise(timeout, ready) {
		const interval = 10;
		timeout = timeout || this.defaultTimeout;
		const deferred = this.q.defer();
		let elapsed = 0;
		const intervalId = setInterval(() => {
				elapsed += interval;
				if (ready.flag) {
					clearInterval(intervalId);
					deferred.resolve();
				} else if (elapsed >= timeout) {
					clearInterval(intervalId);
					deferred.reject({exception: "Timeout (" + timeout + "ms)"});
				}
			},
			interval);
		
		return deferred.promise;
	}
	
	getDeviceInfo(config, deviceInfo) {
		config = config || {};
		const timeout = config.timeout || this.defaultTimeout;
		
		//return value from cache (it may be null)
		if (!config.async || deviceInfo !== null) {
			return this.q.when(deviceInfo);
		}
		
		//return promise and get device info asynchronously
		let ready = {flag: false}; // should be reference type
		const payloadPromise = this.messenger.portalMessage("device", "get-device-info")
			.then(payload => {
				ready.flag = true;
				return payload;
			});
		return this.q.all([this.getTimeoutPromise(timeout, ready), payloadPromise]);
	}
}



// WEBPACK FOOTER //
// ./src/scripts/services/desktopDataProvider.js